import React from 'react';
import data from './data.json';
import './style.scss';
import FinancialCalendarItem from './FinancialCalendarItem.js';

function FinancialCalendar() {
    return (
        <div className="financial-calendar-wrapper">
            {data.items.map((item, index) => (
                <FinancialCalendarItem item={item} key={index} />
            ))}
        </div>
    );
}

export default FinancialCalendar;
